export function updateElement(selector, html) {
  if (html === undefined) return
  
  const element = document.querySelector(selector)
  if (element) {
    element.innerHTML = html
  }
}
